// tslint:disable:no-expression-statement
import '../assets/styles.scss'

// document ready
$((): void => {
  console.log('* jquery loaded:', `v${$.fn.jquery}`)
})
